export const PROSPECT_STATUSES = {
	PENDING: 'new',
	INVITE_SENT: 'invitation_sent',
	APP_STARTED: 'application_started',
	APP_COMPLETED: 'application_completed',
	ARCHIVED: 'archived'
} as const;

export type ProspectStatusValue = (typeof PROSPECT_STATUSES)[keyof typeof PROSPECT_STATUSES];

export interface Prospect {
	prospectID: string;
	unitID: string | null;
	propertyID: string | null;
	contactID: string | null;
	invitationID: string | null;
	applicationID: string | null;
	name: string;
	email: string;
	phone: string | null;
	message: string | null;
	leadSource: string | null;
	dateTimeCreated: string;
	dateTimeModified: string;
	status: ProspectStatusValue;
}
